import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-515376a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "prize-img-list"
};
const _hoisted_2 = ["src", "onClick"];
const _hoisted_3 = ["src", "onClick"];
const _hoisted_4 = ["src", "onClick"];
const _hoisted_5 = {
  key: 1,
  class: "draw_detail draw_detail_lottery"
};
const _hoisted_6 = {
  class: "draw_label"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "strong"
}, "奖品", -1));
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 抽奖规则 ");
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("text", {
  class: "iconfont icon-nestmore"
}, null, -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "draw_label six"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "strong"
}, "参与条件")], -1));
const _hoisted_12 = {
  class: "prize-ul"
};
const _hoisted_13 = {
  class: "prize-li-label"
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 0,
  class: "share-container"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "draw_label"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "strong label-title"
}, "分享方式：")], -1));
const _hoisted_17 = {
  class: "prize-tips prize-tips-label"
};
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"eg_cover lp_flex lptems_center lp_justify lptems_center\" data-v-515376a6><img class=\"prize-img\" src=\"https://s.moimg.net/images/draw_cover_1.png\" data-v-515376a6><img class=\"prize-img\" src=\"https://s.moimg.net/images/draw_cover_2.png\" data-v-515376a6></div><div class=\"draw_label\" data-v-515376a6><div class=\"strong label-title\" data-v-515376a6>分享时间：</div></div>", 2);
const _hoisted_20 = {
  key: 0,
  class: "draw_label_time"
};
const _hoisted_21 = {
  class: "time-label"
};
const _hoisted_22 = {
  key: 1,
  class: "draw_label_time"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-label"
}, "任何时间分享均可参与抽奖", -1));
const _hoisted_24 = [_hoisted_23];
const _hoisted_25 = {
  key: 1,
  class: "share-container"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "draw_label"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "strong label-title"
}, "支持/购买方式：")], -1));
const _hoisted_27 = {
  class: "prize-tips prize-tips-label"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "prize-tips-line"
}, null, -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "draw_label"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "strong label-title"
}, "抽奖倍率计算：")], -1));
const _hoisted_30 = {
  class: "draw_label_time"
};
const _hoisted_31 = {
  key: 0,
  class: "time-label"
};
const _hoisted_32 = {
  key: 1,
  class: "time-label"
};
const _hoisted_33 = {
  class: "prize-tips prize-tips-label"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "prize-tips-line"
}, null, -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "draw_label"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "strong label-title"
}, "抽奖倍率计算：")], -1));
const _hoisted_36 = {
  class: "draw_label_time"
};
const _hoisted_37 = {
  key: 0,
  class: "time-label"
};
const _hoisted_38 = {
  key: 1,
  class: "time-label"
};
const _hoisted_39 = {
  key: 2,
  class: "share-container"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "draw_label"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "strong label-title"
}, "评论方式：")], -1));
const _hoisted_41 = {
  class: "prize-tips prize-tips-label"
};
const _hoisted_42 = /*#__PURE__*/_createTextVNode("带话题词 ");
const _hoisted_43 = {
  style: {
    "color": "#00C4A1"
  }
};
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 在项目或更新讨论区发布评论参与话题互动");
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "prize-tips-line"
}, null, -1));
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "draw_label"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "strong label-title"
}, "评论示例：")], -1));
const _hoisted_47 = ["innerHTML"];
const _hoisted_48 = {
  key: 3
};
const _hoisted_49 = {
  key: 0,
  class: "apple-des"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "draw_label draw_label_mode"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "strong"
}, "开奖方式")], -1));
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" 项目发起人手动开奖 ");
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-gift"
}, null, -1));
const _hoisted_53 = /*#__PURE__*/_createTextVNode("查看开奖情况 ");
const _hoisted_54 = [_hoisted_52, _hoisted_53];
const _hoisted_55 = {
  key: 2,
  class: "draw_detail"
};
const _hoisted_56 = {
  class: "draw_label"
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "strong"
}, "奖品", -1));
const _hoisted_58 = /*#__PURE__*/_createTextVNode("抽奖规则");
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("text", {
  class: "iconfont icon-nestmore"
}, null, -1));
const _hoisted_60 = [_hoisted_58, _hoisted_59];
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "draw_label six"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "strong"
}, [/*#__PURE__*/_createTextVNode("抽奖规则"), /*#__PURE__*/_createElementVNode("text", {
  class: "draw_rule"
}, "需满足全部条件")])], -1));
const _hoisted_62 = {
  class: "prize-ul"
};
const _hoisted_63 = {
  class: "prize-li-label"
};
const _hoisted_64 = {
  key: 0
};
const _hoisted_65 = {
  key: 0,
  class: "share-container"
};
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "draw_label"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "strong label-title"
}, "分享方式：")], -1));
const _hoisted_67 = {
  class: "prize-tips prize-tips-label"
};
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "eg_cover lp_flex lptems_center lp_justify lptems_center",
  style: {
    "border-bottom": "none",
    "margin-bottom": "0",
    "padding-bottom": "0"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "prize-img",
  src: "https://s.moimg.net/images/draw_cover_1.png"
}), /*#__PURE__*/_createElementVNode("img", {
  class: "prize-img",
  src: "https://s.moimg.net/images/draw_cover_2.png"
})], -1));
const _hoisted_69 = {
  key: 1,
  class: "share-container"
};
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "draw_label"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "strong label-title"
}, "支持/购买方式：")], -1));
const _hoisted_71 = {
  class: "prize-tips prize-tips-label"
};
const _hoisted_72 = {
  key: 2
};
const _hoisted_73 = {
  key: 0,
  class: "apple-des"
};
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "draw_label six"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "strong"
}, "开奖时间")], -1));
const _hoisted_75 = {
  class: "prize-ul"
};
const _hoisted_76 = {
  key: 0,
  class: "prize-li"
};
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "注：助力值越高，中奖机会越大", -1));
const _hoisted_78 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Rules = _resolveComponent("Rules");
  return _openBlock(), _createElementBlock("div", null, [$options.imgs.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$options.imgs.length == 1 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($options.imgs, (item, index) => {
    return _openBlock(), _createElementBlock("img", {
      key: index,
      class: "one-img",
      src: _ctx.$imgUrlFilter(item, 750),
      onClick: $event => $options.showBigImg(index)
    }, null, 8, _hoisted_2);
  }), 128)) : $options.imgs.length == 2 || $options.imgs.length == 3 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList($options.imgs, (item, index) => {
    return _openBlock(), _createElementBlock("img", {
      key: index,
      class: "two-img",
      src: _ctx.$imgUrlFilter(item, 680),
      onClick: $event => $options.showBigImg(index)
    }, null, 8, _hoisted_3);
  }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
    key: 2
  }, _renderList($options.imgs, (item, index) => {
    return _openBlock(), _createElementBlock("img", {
      key: index,
      class: "three-img",
      src: _ctx.$imgUrlFilter(item, 444),
      onClick: $event => $options.showBigImg(index)
    }, null, 8, _hoisted_4);
  }), 128))])) : _createCommentVNode("", true), $props.updateInfo.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", {
    class: "rule",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.showRule && $options.showRule(...args))
  }, _hoisted_10)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.updateInfo.prize_info, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "prize-p"
    }, _toDisplayString(item.prize_name) + "，共" + _toDisplayString(item.win_number) + "人 ", 1);
  }), 128)), _hoisted_11, _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.ruleArr, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "prize-li"
    }, [_createElementVNode("div", _hoisted_13, _toDisplayString(index + 1) + ". " + _toDisplayString(item.title), 1), item.label || item.title.includes('支持/购买项目') ? (_openBlock(), _createElementBlock("div", _hoisted_14, [item.title.indexOf('分享') > -1 && $props.updateInfo.activity_info.rule_two ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString($props.updateInfo.activity_info.rule_two), 1), _hoisted_18, $props.updateInfo.activity_info.share_stime != '0000-00-00 00:00:00' || $props.updateInfo.activity_info.share_etime != '0000-00-00 00:00:00' ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, "需在 " + _toDisplayString($props.updateInfo.activity_info.share_stime) + " 至 " + _toDisplayString($props.updateInfo.activity_info.share_etime) + " 期间操作分享，否则无法参与抽奖", 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))])) : item.title.indexOf('支持/购买项目') > -1 && ($props.updateInfo.activity_info.reward_name || Number($props.updateInfo.activity_info.full_money) > 0) ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_hoisted_26, Number($props.updateInfo.activity_info.full_money) > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("div", _hoisted_27, "在项目中支付金额达到 ¥" + _toDisplayString($props.updateInfo.activity_info.full_money) + " 即可参与抽奖", 1), _hoisted_28, _hoisted_29, _createElementVNode("div", _hoisted_30, [$props.updateInfo.activity_info.draw_type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_31, "符合参与条件时，每个用户中奖机会相等")) : $props.updateInfo.activity_info.draw_type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_32, "用户支持项目金额每满" + _toDisplayString($props.updateInfo.activity_info.full_money) + "元，获得1次参与抽奖机会", 1)) : _createCommentVNode("", true)])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createElementVNode("div", _hoisted_33, _toDisplayString($props.updateInfo.activity_info.reward_name), 1), _hoisted_34, _hoisted_35, _createElementVNode("div", _hoisted_36, [$props.updateInfo.activity_info.draw_mode == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_37, "符合参与条件时，每个用户中奖机会相等")) : $props.updateInfo.activity_info.draw_mode == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_38, "用户每支付一笔符合参与条件的订单，获得 1 倍中奖机会（例如支付1单中奖机会=1倍，支付2单中奖机会")) : _createCommentVNode("", true)])], 64))])) : item.title.indexOf('带话题参与项目讨论') > -1 && $props.updateInfo.activity_info.rule_five ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, [_hoisted_42, _createElementVNode("span", _hoisted_43, _toDisplayString($props.updateInfo.activity_info.rule_five.topic), 1), _hoisted_44]), _hoisted_45, _hoisted_46, _createElementVNode("div", {
      class: "prize-tips prize-tips-label",
      innerHTML: $options.getText($props.updateInfo.activity_info.rule_five.topic_example, $props.updateInfo.activity_info.rule_five.topic)
    }, null, 8, _hoisted_47)])) : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(item.label), 1))])) : _createCommentVNode("", true)]);
  }), 128))]), $options.isIOS ? (_openBlock(), _createElementBlock("div", _hoisted_49, " 本次活动和Apple公司无关，最终解释权归摩点所有 ")) : _createCommentVNode("", true), _hoisted_50, _createElementVNode("div", null, [$props.updateInfo.activity_info.draw_time == '0000-00-00 00:00:00' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_51], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createTextVNode(" 已设置" + _toDisplayString($props.updateInfo.activity_info.draw_time) + "，开奖过程可能需要几分钟时间，请耐心等待。 ", 1)], 64))]), _createElementVNode("div", {
    class: "show_draw_btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.showDrawResult && $options.showDrawResult(...args))
  }, _hoisted_54)])) : _createCommentVNode("", true), $props.updateInfo.type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_hoisted_57, _createElementVNode("div", {
    class: "rule",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.showRule && $options.showRule(...args))
  }, _hoisted_60)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.updateInfo.prize_info, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "prize-p"
    }, _toDisplayString(item.prize_name) + "，共" + _toDisplayString(item.win_number) + "人 ", 1);
  }), 128)), _hoisted_61, _createElementVNode("div", _hoisted_62, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.ruleArr, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "prize-li"
    }, [_createElementVNode("div", _hoisted_63, _toDisplayString(index + 1) + ". " + _toDisplayString(item.title), 1), item.label ? (_openBlock(), _createElementBlock("div", _hoisted_64, [$props.updateInfo.activity_info.rule_two && item.label.indexOf('分享') > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_hoisted_66, _createElementVNode("div", _hoisted_67, _toDisplayString(item.label), 1), _hoisted_68])) : $props.updateInfo.activity_info.reward_name ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_hoisted_70, _createElementVNode("div", _hoisted_71, _toDisplayString(item.label), 1)])) : (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString(item.label), 1))])) : _createCommentVNode("", true)]);
  }), 128))]), $options.isIOS ? (_openBlock(), _createElementBlock("div", _hoisted_73, " 本次活动和Apple公司无关，最终解释权归摩点所有 ")) : _createCommentVNode("", true), _hoisted_74, _createElementVNode("div", _hoisted_75, [$props.updateInfo.activity_info.draw_time ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString($props.updateInfo.activity_info.draw_time), 1)) : _createCommentVNode("", true)]), _ctx.userId ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$props.updateInfo.activity_info.if_success == 2 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "show_draw_btn",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.showResult && $options.showResult(...args))
  }, " 查看抽奖结果 ")) : $props.updateInfo.activity_info.if_success == 0 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "show_draw_btn",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.showResult && $options.showResult(...args))
  }, _toDisplayString($props.updateInfo.activity_info.if_draw == 1 ? '邀请好友助力' : '参与抽选'), 1)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "show_draw_btn",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.showResult && $options.showResult(...args))
  }, " 参与抽选 ")), _hoisted_77, _hoisted_78])) : _createCommentVNode("", true), _createVNode(_component_Rules, {
    show: $data.show,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => $data.show = $event)
  }, null, 8, ["show"])]);
}